import { KYMW1100Model } from './../kymw1100.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 取引先情報取得クラス
 *
 * @export GetSupplierService
 * @class GetSupplierService
 * @extends {PlessResponder}
 */
@Injectable()
export class GetSupplierService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW1100Model;
  private supplierCode: string;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetSupplierService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        SupplierCode: this.supplierCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetSupplierService
   */
  execute(model: KYMW1100Model, supplierCode: string, successFunc: Function = null): void {
    this.model = model;
    this.supplierCode = supplierCode;
    this.successFunc = successFunc;
    this.send('getSupplier', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetSupplierService
   */
  success(data: any): void {
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
